import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextAreaHLPure } from '../../pures'
import { Grid } from '@material-ui/core'
import './dialog-sign.css'
import { useState } from 'react'
import InteractiveDialog from '../InteractiveDialog/InteractiveDialog'
import ButtonHLPure from '../buttonHL/buttonHL.pure'

const DialogRejectSignature = (props) => {
  const { t } = useTranslation()

  const [comments, setComments] = useState('')

  const handleChangeComments = (event) => {
    setComments(event.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    props.onSubmitReject({ comments })
  }

  return (
    <>
      {(props.userCanSign === true || props.authorizerCanSign === true) &&
        props.signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
        <div>
          {props.visibleReject && (
            <InteractiveDialog
              title={t('dialogRejectSignature.titleRejectSignRequest')}
              onClose={props.toggleDialogReject}
              cancelBtnTitle={t('button.cancel')}
              saveBtnTitle={t('button.send')}
              onSave={handleSubmit}
              CustomButtons={
                <>
                  <ButtonHLPure
                    nameBtn={t('button.cancel')}
                    onClickBtn={props.toggleDialogReject}
                  />
                  <ButtonHLPure
                    nameBtn={t('button.send')}
                    primary
                    onClickBtn={handleSubmit}
                    disabled={!!props.showLoadingRequesting}
                  />
                </>
              }
            >
              <Grid
                container
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className='dialogRejectSignature-titleRejectSignRequest-contaiiner'
              >
                <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                  <TextAreaHLPure
                    labelTextArea={`${t('dialogRejectSignature.rejectRequest')} ${props.userRequestingSign}?`}
                    characterLimit={500}
                    placeholder={t('dialogRejectSignature.reason')}
                    valueTextData={comments}
                    handleChangeTextArea={handleChangeComments}
                    rowsTextArea={4}
                    errorInput={props.errorTextArea}
                    errorTextArea={t('dialogRejectSignature.validTextArea')}
                  />
                </Grid>
              </Grid>
            </InteractiveDialog>
          )}
        </div>
      ) : null}
    </>
  )
}

export { DialogRejectSignature as default }
